import { render, staticRenderFns } from "./CreditsafeRatingRenderer.vue?vue&type=template&id=597bc5fb&"
import script from "./CreditsafeRatingRenderer.vue?vue&type=script&lang=js&"
export * from "./CreditsafeRatingRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports